import { Monitor, Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";

type Theme = "light" | "dark" | "system";

function applyTheme(theme: Theme) {
  const dark = theme === "dark" || (theme === "system" && matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.dataset.theme = dark ? "dark" : "light";
  document.documentElement.dataset.themePreference = theme;
  localStorage.setItem("kl-report-theme", theme);
}

export function ThemeControl() {
  const [theme, setTheme] = useState<Theme>(() => (localStorage.getItem("kl-report-theme") as Theme | null) ?? "system");

  useEffect(() => {
    applyTheme(theme);
    const media = matchMedia("(prefers-color-scheme: dark)");
    const listener = () => theme === "system" && applyTheme("system");
    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, [theme]);

  return (
    <div className="theme-control" aria-label="Theme">
      {(["light", "dark", "system"] as Theme[]).map((value) => {
        const Icon = value === "light" ? Sun : value === "dark" ? Moon : Monitor;
        return (
          <button
            key={value}
            type="button"
            className={theme === value ? "is-active" : ""}
            onClick={() => setTheme(value)}
            aria-label={`${value} theme`}
            aria-pressed={theme === value}
          >
            <Icon size={15} />
          </button>
        );
      })}
    </div>
  );
}
